(() => {
  const initProductFocus = (root) => {
    if (!root || root.dataset.productFocusReady === 'true') return;

    const image = root.querySelector('[data-product-focus-image]');
    const swatches = Array.from(root.querySelectorAll('[data-product-focus-swatch]'));
    const colorName = root.querySelector('[data-product-focus-color-name]');
    const detailLink = root.querySelector('[data-product-focus-link]');

    if (!swatches.length) {
      root.dataset.productFocusReady = 'true';
      return;
    }

    root.dataset.productFocusReady = 'true';

    const activate = (swatch) => {
      if (!swatch) return;

      swatches.forEach((item) => {
        const active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (colorName) colorName.textContent = swatch.dataset.colorName || '';

      if (detailLink && swatch.dataset.variantUrl) {
        detailLink.href = swatch.dataset.variantUrl;
      }

      if (!image || !swatch.dataset.imageSrc || image.src === swatch.dataset.imageSrc) return;

      image.classList.add('is-changing');
      const next = new Image();
      next.src = swatch.dataset.imageSrc;
      next.onload = () => {
        image.src = next.src;
        if (swatch.dataset.imageSrcset) image.srcset = swatch.dataset.imageSrcset;
        image.alt = swatch.dataset.imageAlt || image.alt;
        requestAnimationFrame(() => image.classList.remove('is-changing'));
      };
      next.onerror = () => image.classList.remove('is-changing');
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => activate(swatch));
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-product-focus]').forEach(initProductFocus);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
